import React, { useState, useRef, ReactNode, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper";
import classNames from "classnames";
import CarouselButtons from "../CarouselButtons/CarouselButtons";

interface ICarousel {
    displayData: { key: string; data: ReactNode }[];
    previousSlideAriaLabel: string;
    nextSlideAriaLabel: string;
    spaceBetweenSlides?: number;
    isOrangeButtons?: boolean;
    isMemberTickets?: boolean;
    itemsPerSlideDesktop?: number | "auto";
    itemsPerSlideMobile?: number | "auto";
    arrowColor?: string;
}

export const Carousel = ({
    displayData,
    previousSlideAriaLabel,
    nextSlideAriaLabel,
    spaceBetweenSlides = 20,
    isOrangeButtons = false,
    isMemberTickets = false,
    itemsPerSlideDesktop = "auto",
    itemsPerSlideMobile = "auto",
    arrowColor = "white",
}: ICarousel) => {
    const swiperRef = useRef<SwiperType>();
    const [hideLeftButton, setHideLeftButton] = useState(true);
    const [hideRightButton, setHideRightButton] = useState(false);
    const [centerSlides, setCenterSlides] = useState(false);

    const updateButtonsVisibility = () => {
        if (swiperRef.current) {
            setHideLeftButton(swiperRef.current.isBeginning);
            setHideRightButton(swiperRef.current.isEnd);
        }
    };

    useEffect(() => {
        if (displayData.length < 4) {
            setHideRightButton(true);
            setCenterSlides(true);
        }
    }, [displayData.length]);

    if (!displayData.length) return null;

    return (
        <div className="Carousel">
            <CarouselButtons
                hideLeftButton={hideLeftButton}
                hideRightButton={hideRightButton}
                isOrangeButtons={isOrangeButtons}
                arrowColor={arrowColor}
                previousSlideAriaLabel={previousSlideAriaLabel}
                nextSlideAriaLabel={nextSlideAriaLabel}
                onLeftClick={() => {
                    swiperRef.current?.slidePrev();
                    updateButtonsVisibility();
                }}
                onRightClick={() => {
                    swiperRef.current?.slideNext();
                    updateButtonsVisibility();
                }}
            />

            <div
                className={classNames("Carousel__Items", {
                    "Carousel__Items--center-slides": centerSlides && isMemberTickets,
                })}
            >
                <Swiper
                    slidesPerView={itemsPerSlideMobile}
                    breakpoints={{
                        1023: {
                            spaceBetween: spaceBetweenSlides,
                            allowTouchMove: false,
                            slidesPerView: itemsPerSlideDesktop,
                        },
                    }}
                    allowTouchMove
                    spaceBetween={16}
                    className="mySwiper"
                    onBeforeInit={(swiper) => (swiperRef.current = swiper)}
                    onSlideChange={updateButtonsVisibility}
                >
                    {displayData.map(({ key, data }, index) => (
                        <SwiperSlide
                            className={classNames("Carousel__Slide", {
                                "Carousel__Slide--no-margin":
                                    centerSlides && index === displayData.length - 1 && isMemberTickets,
                            })}
                            key={key}
                        >
                            {data}
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};
